module.exports = __webpack_public_path__ + "img/aboutus.97d89bd3.jpg";